import { NavLink, useLocation, useSearchParams } from 'react-router-dom';
import { appendLobbyParams } from '@/utils/lobbyNavigation';

const tabs = [
  { name: 'Play', path: '/play' },
  { name: 'My Games', path: '/my-picks' },
  { name: 'Recent', path: '/results' },
];

/**
 * Tab Navigation Component
 * 3 main tabs: Play, My Games, Recent
 * Play shows PlayView (grid for selecting/viewing contest)
 *
 * When entering Play view from Recent (via /play?mode=results), the Recent tab
 * stays highlighted so users retain context.
 */
export default function TabNavigation() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isPlayFromRecent = location.pathname === '/play' && searchParams.get('mode') === 'results';

  const getIsActive = (tabPath: string, defaultIsActive: boolean) => {
    // When viewing a game from Recent tab, keep Recent highlighted instead of Play
    if (isPlayFromRecent) {
      if (tabPath === '/results') return true;
      if (tabPath === '/play') return false;
    }
    return defaultIsActive;
  };

  return (
    <nav className="flex border-b border-[#373737] bg-[#121212]">
      {tabs.map(tab => (
        <NavLink
          key={tab.path}
          to={appendLobbyParams(tab.path, searchParams)}
          className={({ isActive }) => {
            const shouldBeActive = getIsActive(tab.path, isActive);
            return `flex-1 py-3 text-center text-sm font-medium transition-colors relative ${
              shouldBeActive ? 'text-white' : 'text-zinc-500 hover:text-zinc-300'
            }`;
          }}
        >
          {({ isActive }) => {
            const shouldBeActive = getIsActive(tab.path, isActive);
            return (
              <>
                {tab.name}
                {shouldBeActive && (
                  <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#53d337]" />
                )}
              </>
            );
          }}
        </NavLink>
      ))}
    </nav>
  );
}
